import { AbstractFilterBuilder } from "./AbstractFilterBuilder";

export class BunitFilterBuilder extends AbstractFilterBuilder {

    public build(value: string): string {
        return `["${this.table}","${this.field}","=","${value}"]`
    }
    
}